export const selectSuggestions = state => state?.suggestions;
export const selectSuggestionsState = state => state?.suggestions?.suggestions;
